import React from 'react';
import Strip from '../citizen/Home/TCP-HP/Strip';
import GovtStrip from '../citizen/Home/TCP-HP/GovtStrip';
import Navbar from '../citizen/Home/TCP-HP/Navbar';
import Footer from '../citizen/Home/NewTCP/Footer';

const TCPCheckStatus = () => {
  return (
    <div>
        <Strip/>
            <GovtStrip/>
            <Navbar/>
            <div>Akash bhai .....!</div>
            <Footer />
    </div>
  );
};

export default TCPCheckStatus;